export const Monogram = ({ className = "w-10 h-10" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <defs>
            <linearGradient id="mg-g" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#BF953F" />
                <stop offset="0.25" stopColor="#FCF6BA" />
                <stop offset="0.5" stopColor="#B38728" />
                <stop offset="0.75" stopColor="#FBF5B7" />
                <stop offset="1" stopColor="#AA771C" />
            </linearGradient>
        </defs>
        <rect x="2" y="2" width="60" height="60" rx="14" fill="url(#mg-g)" />
        <g fill="#070709">
            <rect x="29" y="14" width="6" height="26" />
            <rect x="17" y="26" width="6" height="20" />
            <rect x="41" y="26" width="6" height="20" />
            <rect x="17" y="40" width="30" height="6" />
        </g>
    </svg>
);
